import React from 'react';

import { Button, Icon } from 'antd';

export default class ImgPreview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            top: 0,
            left: 0,
            index: this.props.index || 0,
            kuan: 0,
            show: false,
            visible: false,
            disableLeft: false,
            disableRight: false
        }
        this.pressDown = false;
        this.initialY = null;
        this.initialX = null;
    }
    componentDidMount() {
        // this.tu_init();
    }
    show(index) {
        this.setState({
            visible: true,
            index: index,
            disableLeft: index === 0,
            disableRight: index === this.props.pic.length - 1
        }, () => {
            this.rootRef.focus();
        })
    }
    hide() {
        this.setState({
            visible: false
        })
    }
    tu_init() {
        this.setState({
            kuan: 0,
            show: false
        })
        console.log(this.refs);
        // debugger;
        let lunxun = setInterval(() => {
            if (this.refs && this.imgRef && this.imgRef.offsetHeight && this.imgRef.style.width === '400px') {
                let node = this.imgRef;
                console.log(this.imgRef.offsetHeight)
                let top = (document.body.offsetHeight - this.imgRef.offsetHeight) / 2;
                let left = (document.body.offsetWidth - this.imgRef.offsetWidth) / 2;
                this.setState({
                    // top: top,
                    // left: left,
                    show: true
                })
                node.attributes['data-rotate'] = 0;
                node.style.transform = 'rotate(' + 0 + 'deg)';
                node.style.top = top + 'px';
                node.style.left = left + 'px';
                node.attributes['x'] = left;
                node.attributes['y'] = top;
                node.attributes['firstLoad'] = true;
                clearInterval(lunxun)
            }
        }, 5)
    }


    onMouseDown(e) {
        e.preventDefault();
        this.pressDown = true;
        let node = this.imgRef;
        this.initialY = e.clientY - node.attributes['y'] || 0;
        this.initialX = e.clientX - node.attributes['x'] || 0;
    }
    onMouseUp(e) {
        this.pressDown = false
    }
    onMouseMove(e) {
        if (this.pressDown) {
            let node = this.imgRef;
            let top = e.clientY - this.initialY;
            let left = e.clientX - this.initialX;
            // this.setState({
            //     top: top,
            //     left: left
            // })
            node.style.top = top + 'px';
            node.style.left = left + 'px';
            node.attributes['x'] = left;
            node.attributes['y'] = top;
        }
    }
    onWheel(e) {
        let isZoomout;
        if (e.deltaY < 0) {
            isZoomout = false;
        } else {
            isZoomout = true;
        }
        let node = this.imgRef;
        var position = !node.attributes['firstLoad'] ? {
            x: parseFloat(node.attributes['x']),
            y: parseFloat(node.attributes['y']),
            w: parseFloat(node.attributes['w']),
            h: parseFloat(node.attributes['h']),
        } : {
                x: node.offsetLeft,
                y: node.offsetTop,
                w: node.width,
                h: node.height,
            };
        node.attributes['firstLoad'] = false;
        var beforeWidth = position.w; // 图片缩放前的宽度
        var beforeLeft = position.x; // 缩放前的左距离
        var beforeHeight = position.h; // 缩放前的高度
        var beforeTop = position.y; // 缩放前的top

        let clientX = window.event.clientX;
        let clientY = window.event.clientY;

        var perX = (clientX - beforeLeft) / beforeWidth; // 缩放前鼠标滚轮所在图片的横坐标位置所占的比例
        var perY = (clientY - beforeTop) / beforeHeight; // 缩放前鼠标滚轮所在图片的纵坐标位置所占的比例

        var afterWidth, afterHeight; // 缩放后图片的宽高
        afterWidth = isZoomout ? beforeWidth / 1.2 : beforeWidth * 1.2;

        // node.style({// 设置图片宽度
        //     'width': afterWidth + 'px',
        //     'max-width': 'none'
        // });

        afterHeight = isZoomout ? beforeHeight / 1.2 : beforeHeight * 1.2;

        var left = beforeLeft + (beforeWidth - afterWidth) * perX;
        var top = beforeTop + (beforeHeight - afterHeight) * perY;

        // node.style = {
        //     ...node.style,
        //     'width': afterWidth + 'px',
        //     'max-width': 'none',
        //     'top': top.toFixed(0) + 'px',
        //     'left': left.toFixed(0) + 'px'
        // }
        node.style.width = afterWidth + 'px';
        node.style.top = top + 'px';
        node.style.left = left + 'px';

        // this.setState({
        //     kuan: afterWidth,
        //     left: left,
        //     top: top
        // });
        node.attributes['x'] = left;
        node.attributes['y'] = top;
        node.attributes['w'] = afterWidth;
        node.attributes['h'] = afterHeight;
    }
    changeLeft(e) {
        let index = this.state.index;
        if (index !== 0) {
            this.setState({
                index: index - 1,
                disableLeft: index - 1 === 0,
                disableRight: index - 1 === this.props.pic.length
            }, () => {
                let node = this.imgRef;
                node.style.width = '400px';
                // this.tu_init();
            })
        } else {
            // this.props.left_done()
        }
    }
    changeRight(e) {
        let index = this.state.index;
        if (index < this.props.pic.length - 1) {
            this.setState({
                index: this.state.index + 1,
                disableLeft: index + 1 === 0,
                disableRight: index + 1 === this.props.pic.length - 1
            }, () => {
                let node = this.imgRef;
                node.style.width = '400px';
                // this.tu_init();
            })
        } else {
            // this.props.right_done()
        }
    }
    rotateImg(index) {
        let node = this.imgRef;
        var rotate = index * 90;
        node.attributes['data-rotate'] = index;
        node.style.transform = 'rotate(' + rotate + 'deg)';
        // node.style({
        //     'transform': 'rotate(' + rotate + 'deg)',
        //     '-ms-transform': 'rotate(' + rotate + 'deg)',
        //     '-moz-transform': 'rotate(' + rotate + 'deg)',
        //     '-webkit-transform': 'rotate(' + rotate + 'deg)',
        //     '-o-transform': 'rotate(' + rotate + 'deg)'
        // })
    }

    render() {
        return (
            this.state.visible ? <div ref={ref => this.rootRef = ref} className="freesia-img-preview" tabIndex="0" onKeyUp={e => {
                if (e.keyCode === 37) {
                    this.changeLeft();
                } else if (e.keyCode === 39) {
                    this.changeRight();
                }
            }} style={{
                zIndex: 99
            }} onMouseUp={this.onMouseUp.bind(this)} onWheel={this.onWheel.bind(this)} onMouseMove={this.onMouseMove.bind(this)}>
                <div className="img-watch-modal"></div>
                <div className="freesia-img-preview_head">
                    <div className="freesia-img-preview_head_l">
                        {this.state.index + 1}&nbsp;/&nbsp;{this.props.pic.length}
                    </div>
                    {this.props.tit.length == 0 ? null : <div className="freesia-img-preview_head_m">
                        {this.props.tit[this.state.index]}
                    </div>}
                    <div className="freesia-img-preview_head_r" onClick={this.hide.bind(this)}>
                        <Icon type="close" style={{
                            fontSize: "18px"
                        }} />
                    </div>
                </div>
                <Button disabled={this.state.disableLeft} className="img-watch-btn left" onClick={this.changeLeft.bind(this)}>
                    <Icon type="left" />
                </Button>
                <img onMouseDown={this.onMouseDown.bind(this)}
                    ref={ref => {
                        this.imgRef = ref;
                    }} src={this.props.pic[this.state.index]}
                    style={{
                        visibility: this.state.show ? 'inherit' : 'hidden',
                        top: '0px',
                        left: '0px',
                        width: '400px',
                        color: "#fff",
                        height: "auto"
                    }}
                    alt="仅支持图片的预览" onLoad={this.tu_init.bind(this)} onError={this.tu_init.bind(this)} />

                <Button disabled={this.state.disableRight} className="img-watch-btn right" onClick={this.changeRight.bind(this)}>
                    <Icon type="right" />
                </Button>
                <div className="rotate">
                    <Button type="link" onClick={() => {
                        let index = this.imgRef.attributes['data-rotate'] || 0;
                        this.rotateImg(index - 1);
                    }}>
                        <Icon type="undo" />
                    </Button>
                    <Button type="link" onClick={() => {
                        let index = this.imgRef.attributes['data-rotate'] || 0;
                        this.rotateImg(index + 1);
                    }}>
                        <Icon type="redo" />
                    </Button>
                </div>
                {/* {this.props.describe.length == 0 ? null : <div className="freesia-img-preview_miaoshu">
                    {this.props.describe[this.state.index]}
                </div>} */}
            </div> : null
        )
    }
}